/* Drag-and-drop reordering for the items of an ng-repeat, on the browser's own drag events.
   Put it on the repeated element:

	<div ng-repeat="item in list" drag-reorder="move($from, $to)" drag-reorder-index="$index">
		<span class="drag-reorder-handle">...</span>

   A drag only starts from inside .drag-reorder-handle, so text in the item's inputs can still be
   selected with the mouse. On drop the expression is evaluated with $from (the dragged item's index)
   and $to (the index it should be inserted before, counted in the list as it was before the move).
   While dragging, the item carries .is-dragging and the drop target .drop-before / .drop-after. */
app.directive("dragReorder", [function () {
	// One drag at a time across the page, so the index being dragged can live here.
	let dragFromIndex = null;

	return {
		restrict: "A",
		link: function (scope, element, attrs) {
			const el = element[0];

			function clearDropMarker() {
				el.classList.remove("drop-before", "drop-after");
			}

			function dropsAfter(event) {
				const rect = el.getBoundingClientRect();
				return event.clientY > rect.top + rect.height / 2;
			}

			el.addEventListener("mousedown", function (event) {
				el.draggable = !!(event.target.closest && event.target.closest(".drag-reorder-handle"));
			});

			el.addEventListener("dragstart", function (event) {
				if (!el.draggable) return;
				dragFromIndex = scope.$eval(attrs.dragReorderIndex);
				event.dataTransfer.effectAllowed = "move";
				// Firefox will not start a drag without some data set.
				event.dataTransfer.setData("text/plain", "");
				el.classList.add("is-dragging");
			});

			el.addEventListener("dragover", function (event) {
				// Ignore anything else being dragged over, such as a file headed for an image input.
				if (dragFromIndex === null) return;
				event.preventDefault();
				event.dataTransfer.dropEffect = "move";
				const after = dropsAfter(event);
				el.classList.toggle("drop-after", after);
				el.classList.toggle("drop-before", !after);
			});

			el.addEventListener("dragleave", function (event) {
				if (!el.contains(event.relatedTarget)) clearDropMarker();
			});

			el.addEventListener("drop", function (event) {
				if (dragFromIndex === null) return;
				event.preventDefault();
				const from = dragFromIndex;
				const to = scope.$eval(attrs.dragReorderIndex) + (dropsAfter(event) ? 1 : 0);
				clearDropMarker();
				scope.$apply(function () {
					scope.$eval(attrs.dragReorder, { $from: from, $to: to });
				});
			});

			el.addEventListener("dragend", function () {
				dragFromIndex = null;
				el.draggable = false;
				el.classList.remove("is-dragging");
				clearDropMarker();
			});
		},
	};
}]);
